import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Routes } from "./navigation";
import { ToastProvider } from "./components/ToastNotification/ToastContext";
import { CartProvider } from "./CartContext";
import "./custom.scss";
import User from "./UserContext"; // Import the UserProvider

const App = () => (
  <ToastProvider>
    <Router>
      <User>
        <CartProvider>
          <Routes />
        </CartProvider>
      </User>
    </Router>
  </ToastProvider>
);

export default App;
